import { Action } from 'redux'
import { ModalActions } from '../../reducers/modals/actionNames'

const closeModal = (
  id: string,
  uid: string | undefined = undefined,
): ICloseModal => ({
  id,
  type: ModalActions.CloseModal,
  uid,
})

export interface ICloseModal extends Action<ModalActions.CloseModal> {
  id: string
  uid?: string | undefined
}

export default closeModal
